// extracted by mini-css-extract-plugin
export default {"wrapper":"-06yY9gKQn7i6zaQrVabwQ==","size-32":"wERbu-0EGUag+Ceh7tDlIA==","size-28":"bwC8vUqrsHJdVOgYMZMveg=="};